import { render, staticRenderFns } from "./CompanyOESubDetails.vue?vue&type=template&id=85a7c098&scoped=true&"
import script from "./CompanyOESubDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyOESubDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOESubDetails.vue?vue&type=style&index=0&id=85a7c098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a7c098",
  null
  
)

export default component.exports